export default class ByteReader {
    constructor(buffer) {
        this.buffer_raw = buffer;
        this.buffer = new DataView(buffer);
        this.pointer = 0;
        this.position = 1;
        this.current = 0;
        this.length = buffer.byteLength;
    }
    /**
     * Reads unsigned 8 bit from the buffer
     *
     * @return {Number} Value read from buffer
     */
    readUInt8() {
        return this.buffer.getUint8(this.pointer++);
    }
    /**
     * Reads unsigned 16 bit from the buffer
     *
     * @return {Number} Value read from buffer
     */
    readUInt16(littleEndian = true) {
        let value = this.buffer.getUint16(this.pointer, littleEndian);
        this.pointer += 2;
        return value;
    }
    /**
     * Reads unsigned 32 bit from the buffer
     *
     * @return {Number} Value read from buffer
     */
    readUInt32(littleEndian = true) {
        let value = this.buffer.getUint32(this.pointer, littleEndian);
        this.pointer += 4;
        return value;
    }
    /**
     * Reads float from the buffer
     *
     * @return {Number} Value read from buffer
     */
    readFloat(littleEndian = true) {
        let value = this.buffer.getFloat32(this.pointer, littleEndian);
        this.pointer += 4;
        return value;
    }
    /**
     * Reads double from the buffer
     *
     * @return {Number} Value read from buffer
     */
    readDouble(littleEndian = true) {
        let value = this.buffer.getFloat64(this.pointer, littleEndian);
        this.pointer += 8;
        return value;
    }
    /**
     * Reads 32-bit unsigned integers value encoded (1-5 bytes)
     *
     * @return {Number} 32-bit unsigned integer
     */
    readEncodedU32() {
        let i = 5, result = 0, nb;
        do
            result += (nb = this.nextByte());
        while ((nb & 128) && --i);
        return result;
    }
    /**
     * Reads data from buffer and returns a string.
     *
     * @returns {String} Decoded string
     */
    readString() {
        let str = "";
        for (;;) {
            let read = this.readUInt8();
            if (read === 0)
                break;
            str += String.fromCharCode(read);
        }
        return str;
    }
    /**
     * Reads a set amount of data from buffer and returns a string.
     *
     * @returns {String} Decoded string
     */
    readStringFixed(readLength) {
        let str = "";
        while (readLength-- > 0) {
            let read = this.readUInt8();
            if (read === 0)
                break;
            str += String.fromCharCode(read);
        }
        return str;
    }
    /**
     * Sets internal pointer to the specified position;
     *
     * @param pos
     */
    seek(pos) {
        this.pointer = pos % this.buffer.byteLength;
    }
    /**
     * Resets position and sets current to next Byte in buffer
     */
    start() {
        this.current = this.nextByte();
        this.position = 1;
    }
    /**
     * Gets next Byte in the buffer and Increment internal pointer
     *
     * @return {Number} Next byte in buffer
     */
    nextByte() {
        return this.pointer >= this.buffer.byteLength ? null : this.buffer.getUint8(this.pointer++);
    }
    /**
     * Reads b bits from current byte in buffer
     *
     * @param {Number} b
     * @return {Number} Bits read from buffer
     */
    readBits(b, signed = false) {
        let n = 0, r = 0, sign = signed && ++n && ((this.current >> (8 - this.position++)) & 1) ? -1 : 1;
        while (n++ < b) {
            if (this.position > 8)
                this.start();
            r = (r << 1) + ((this.current >> (8 - this.position++)) & 1);
        }
        return sign * r;
    }
    /**
     * Read a variable sized integer based on 7 bit bytes.
     * @returns
     */
    readVariableInt() {
        let result = 0;
        for (let i = 0;; i++) {
            let next_byte = this.readUInt8();
            let segment = next_byte & 0x7F;
            result += segment << (7 * i);
            if (!(next_byte & 0x80))
                break;
        }
        return result;
    }
}
